import * as Yup from 'yup';

export const medicalHistoryWeightlossReturning = [
  {
    id: 'initial-conditions',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of the following apply to you? ',
    descriptionFemale: 'Please note that we strongly recommend that you use an effective method of contraception during treatment with a GLP-1 medication and for at least 2 months thereafter.',
    options: [
      {
        value: 'End-stage kidney disease (on or about to be on dialysis)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '9' : '9',
        answer: 'End-stage kidney disease (on or about to be on dialysis)',
        isDisqualifying: true,
      },
      {
        value: 'End-stage liver disease (cirrhosis)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '10' : '10',
        answer: 'End-stage liver disease (cirrhosis)',
        isDisqualifying: true,
      },
      {
        value: 'Current or prior eating disorder (anorexia/bulimia)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '462' : '481',
        isDisqualifying: true,
      },
      {
        value: 'Current suicidal thoughts and/or prior suicidal attempt',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '463' : '482',
        isDisqualifying: true,
      },
      {
        value: 'Cancer (active diagnosis or treatment)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '290' : '290',
        isDisqualifying: true,
      },
      {
        value: 'History of organ transplant on anti-rejection medication',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '466' : '485',
        isDisqualifying: true,
      },
      {
        value: 'Severe gastrointestinal condition (gastroparesis inflammatory bowel disease)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '464' : '483',
        isDisqualifying: true,
      },
      {
        value: 'Current participation in or subscription to another medical weight loss program and/or currently taking another medication for weight loss',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '465' : '484',
        // isDisqualifying: true,
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },
  {
    id: 'currentPregnant',
    type: 'single',
    endpoint: 'obgyn',
    prompt: 'Are you currently pregnant?',
    femaleOnly: true,
    options: [
      {
        questionId: 'LOCAL.83',
        answer: 'Currently pregnant',
        display: 'Currently pregnant',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: 'LOCAL.83',
        answer: 'Planning to be pregnant',
        display: 'Plan to be',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: 'LOCAL.83',
        answer: 'Not pregnant',
        display: 'Not pregnant',
      },
    ],
  },
  {
    id: 'breastfeeding',
    type: 'single',
    endpoint: 'obgyn',
    prompt: 'Are you currently breastfeeding or bottle-feeding with breastmilk?',
    femaleOnly: true,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.582' : 'LOCAL.582',
        answer: 'Y',
        display: 'Yes',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.582' : 'LOCAL.582',
        answer: 'N',
        display: 'No',
      },
    ],
  },

  {
    id: 'hypomed',
    skip: 'medications',
    type: 'medicationPick',
    endpoint: 'medications',
    title: 'Hypothyroidism Medications',
    prompt: 'Please list your hypothyroidism medication',
    other: { questionId: '367151' },
    isInputOnly: false,
    options: [
      {
        value: 'Unithroid',
        hasDosage: false,
        questionId: 313430,
      },
      {
        value: 'Unithroid 100 mcg tablet',
        hasDosage: true,
        questionId: 248353,
      },
      {
        value: 'Unithroid 112 mcg tablet',
        hasDosage: true,
        questionId: 239279,
      },
      {
        value: 'Unithroid 125 mcg tablet',
        hasDosage: true,
        questionId: 239194,
      },
      {
        value: 'Unithroid 137 mcg tablet',
        hasDosage: true,
        questionId: 348963,
      },
      {
        value: 'Unithroid 150 mcg tablet',
        hasDosage: true,
        questionId: 246691,
      },
      {
        value: 'Unithroid 175 mcg tablet',
        hasDosage: true,
        questionId: 252038,
      },
      {
        value: 'Unithroid 200 mcg tablet',
        hasDosage: true,
        questionId: 233390,
      },
      {
        value: 'Unithroid 25 mcg tablet',
        hasDosage: true,
        questionId: 251346,
      },
      {
        value: 'Unithroid 300 mcg tablet',
        hasDosage: true,
        questionId: 245346,
      },
      {
        value: 'Unithroid 50 mcg tablet',
        hasDosage: true,
        questionId: 244067,
      },
      {
        value: 'Unithroid 75 mcg tablet',
        hasDosage: true,
        questionId: 253346,
      },
      {
        value: 'Unithroid 88 mcg tablet',
        hasDosage: true,
        questionId: 226774,
      },
      {
        value: 'Thyrogen',
        hasDosage: false,
        questionId: 310408,
      },
      {
        value: 'Thyrogen 0.9 mg intramuscular solution',
        hasDosage: true,
        questionId: 396360,
      },
      {
        value: 'liothyronine',
        hasDosage: false,
        questionId: 302000,
      },
      {
        value: 'liothyronine (bulk)',
        hasDosage: true,
        questionId: 349888,
      },
      {
        value: 'liothyronine (bulk) 1 mg/gram powder',
        hasDosage: true,
        questionId: 361005,
      },
      {
        value: 'liothyronine (bulk) 100 % powder',
        hasDosage: true,
        questionId: 227807,
      },
      {
        value: 'liothyronine 10 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 230025,
      },
      {
        value: 'liothyronine 25 mcg tablet',
        hasDosage: true,
        questionId: 230116,
      },
      {
        value: 'liothyronine 5 mcg tablet',
        hasDosage: true,
        questionId: 236739,
      },
      {
        value: 'liothyronine 50 mcg tablet',
        hasDosage: true,
        questionId: 246932,
      },
      {
        value: 'LevoxyL',
        hasDosage: false,
        questionId: 300534,
      },
      {
        value: 'LevoxyL 100 mcg tablet',
        hasDosage: true,
        questionId: 231895,
      },
      {
        value: 'LevoxyL 112 mcg tablet',
        hasDosage: true,
        questionId: 252514,
      },
      {
        value: 'LevoxyL 125 mcg tablet',
        hasDosage: true,
        questionId: 227013,
      },
      {
        value: 'LevoxyL 137 mcg tablet',
        hasDosage: true,
        questionId: 257592,
      },
      {
        value: 'LevoxyL 150 mcg tablet',
        hasDosage: true,
        questionId: 225651,
      },
      {
        value: 'LevoxyL 175 mcg tablet',
        hasDosage: true,
        questionId: 233107,
      },
      {
        value: 'LevoxyL 200 mcg tablet',
        hasDosage: true,
        questionId: 229394,
      },
      {
        value: 'LevoxyL 25 mcg tablet',
        hasDosage: true,
        questionId: 239555,
      },
      {
        value: 'LevoxyL 50 mcg tablet',
        hasDosage: true,
        questionId: 250009,
      },
      {
        value: 'LevoxyL 75 mcg tablet',
        hasDosage: true,
        questionId: 233953,
      },
      {
        value: 'LevoxyL 88 mcg tablet',
        hasDosage: true,
        questionId: 226499,
      },
      {
        value: 'Levo-T',
        hasDosage: false,
        questionId: 307279,
      },
      {
        value: 'Levo-T 100 mcg tablet',
        hasDosage: true,
        questionId: 382302,
      },
      {
        value: 'Levo-T 112 mcg tablet',
        hasDosage: true,
        questionId: 382282,
      },
      {
        value: 'Levo-T 125 mcg tablet',
        hasDosage: true,
        questionId: 249338,
      },
      {
        value: 'Levo-T 137 mcg tablet',
        hasDosage: true,
        questionId: 382291,
      },
      {
        value: 'Levo-T 150 mcg tablet',
        hasDosage: true,
        questionId: 382281,
      },
      {
        value: 'Levo-T 175 mcg tablet',
        hasDosage: true,
        questionId: 382295,
      },
      {
        value: 'Levo-T 200 mcg tablet',
        hasDosage: true,
        questionId: 382307,
      },
      {
        value: 'Levo-T 25 mcg tablet',
        hasDosage: true,
        questionId: 382300,
      },
      {
        value: 'Levo-T 300 mcg tablet',
        hasDosage: true,
        questionId: 382289,
      },
      {
        value: 'Levo-T 50 mcg tablet',
        hasDosage: true,
        questionId: 382292,
      },
      {
        value: 'Levo-T 75 mcg tablet',
        hasDosage: true,
        questionId: 382290,
      },
      {
        value: 'Levo-T 88 mcg tablet',
        hasDosage: true,
        questionId: 382303,
      },
      {
        value: 'Euthyrox',
        hasDosage: false,
        questionId: 299187,
      },
      {
        value: 'Euthyrox 100 mcg tablet',
        hasDosage: true,
        questionId: 237400,
      },
      {
        value: 'Euthyrox 112 mcg tablet',
        hasDosage: true,
        questionId: 241991,
      },
      {
        value: 'Euthyrox 125 mcg tablet',
        hasDosage: true,
        questionId: 241213,
      },
      {
        value: 'Euthyrox 137 mcg tablet',
        hasDosage: true,
        questionId: 389367,
      },
      {
        value: 'Euthyrox 150 mcg tablet',
        hasDosage: true,
        questionId: 243351,
      },
      {
        value: 'Euthyrox 175 mcg tablet',
        hasDosage: true,
        questionId: 225746,
      },
      {
        value: 'Euthyrox 200 mcg tablet',
        hasDosage: true,
        questionId: 226297,
      },
      {
        value: 'Euthyrox 25 mcg tablet',
        hasDosage: true,
        questionId: 239811,
      },
      {
        value: 'Euthyrox 50 mcg tablet',
        hasDosage: true,
        questionId: 249702,
      },
      {
        value: 'Euthyrox 75 mcg tablet',
        hasDosage: true,
        questionId: 242062,
      },
      {
        value: 'Euthyrox 88 mcg tablet',
        hasDosage: true,
        questionId: 244029,
      },
      {
        value: 'Synthroid',
        hasDosage: false,
        questionId: 301371,
      },
      {
        value: 'Synthroid 100 mcg tablet',
        hasDosage: true,
        questionId: 231970,
      },
      {
        value: 'Synthroid 112 mcg tablet',
        hasDosage: true,
        questionId: 251383,
      },
      {
        value: 'Synthroid 125 mcg tablet',
        hasDosage: true,
        questionId: 231796,
      },
      {
        value: 'Synthroid 137 mcg tablet',
        hasDosage: true,
        questionId: 276415,
      },
      {
        value: 'Synthroid 150 mcg tablet',
        hasDosage: true,
        questionId: 230662,
      },
      {
        value: 'Synthroid 175 mcg tablet',
        hasDosage: true,
        questionId: 238520,
      },
      {
        value: 'Synthroid 200 mcg tablet',
        hasDosage: true,
        questionId: 230352,
      },
      {
        value: 'Synthroid 25 mcg tablet',
        hasDosage: true,
        questionId: 242725,
      },
      {
        value: 'Synthroid 300 mcg tablet',
        hasDosage: true,
        questionId: 248100,
      },
      {
        value: 'Synthroid 50 mcg tablet',
        hasDosage: true,
        questionId: 248284,
      },
      {
        value: 'Synthroid 75 mcg tablet',
        hasDosage: true,
        questionId: 247491,
      },
      {
        value: 'Synthroid 88 mcg tablet',
        hasDosage: true,
        questionId: 245881,
      },
      {
        value: 'Tirosint',
        hasDosage: false,
        questionId: 355544,
      },
      {
        value: 'Tirosint 100 mcg capsule',
        hasDosage: true,
        questionId: 355490,
      },
      {
        value: 'Tirosint 112 mcg capsule',
        hasDosage: true,
        questionId: 355501,
      },
      {
        value: 'Tirosint 125 mcg capsule',
        hasDosage: true,
        questionId: 355484,
      },
      {
        value: 'Tirosint 13 mcg capsule',
        hasDosage: true,
        questionId: 355475,
      },
      {
        value: 'Tirosint 137 mcg capsule',
        hasDosage: true,
        questionId: 355509,
      },
      {
        value: 'Tirosint 150 mcg capsule',
        hasDosage: true,
        questionId: 355503,
      },
      {
        value: 'Tirosint 175 mcg capsule',
        hasDosage: true,
        questionId: 389564,
      },
      {
        value: 'Tirosint 200 mcg capsule',
        hasDosage: true,
        questionId: 389561,
      },
      {
        value: 'Tirosint 25 mcg capsule',
        hasDosage: true,
        questionId: 355470,
      },
      {
        value: 'Tirosint-SoL 100 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389905,
      },
      {
        value: 'Tirosint-SoL 112 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389897,
      },
      {
        value: 'Tirosint-SoL 125 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389921,
      },
      {
        value: 'Tirosint-SoL 200 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389916,
      },
      {
        value: 'Tirosint-SoL 25 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389911,
      },
      {
        value: 'Tirosint 37.5 mcg capsule',
        hasDosage: true,
        questionId: 402011,
      },
      {
        value: 'Tirosint-SoL 37.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397162,
      },
      {
        value: 'Tirosint 44 mcg capsule',
        hasDosage: true,
        questionId: 402019,
      },
      {
        value: 'Tirosint-SoL 44 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397164,
      },
      {
        value: 'Tirosint 50 mcg capsule',
        hasDosage: true,
        questionId: 355467,
      },
      {
        value: 'Tirosint 62.5 mcg capsule',
        hasDosage: true,
        questionId: 402015,
      },
      {
        value: 'Tirosint-SoL 50 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389922,
      },
      {
        value: 'Tirosint-SoL 62.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397169,
      },
      {
        value: 'Tirosint 75 mcg capsule',
        hasDosage: true,
        questionId: 355469,
      },
      {
        value: 'Tirosint-SoL 75 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389900,
      },
      {
        value: 'Tirosint 88 mcg capsule',
        hasDosage: true,
        questionId: 355496,
      },
      {
        value: 'Tirosint-SoL 88 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389910,
      },
      {
        value: 'Tirosint-SoL 13 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389902,
      },
      {
        value: 'Tirosint-SoL 137 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389899,
      },
      {
        value: 'Tirosint-SoL 150 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389901,
      },
      {
        value: 'Tirosint-SoL 175 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389903,
      },
      {
        value: 'Tirosint-SoL',
        hasDosage: true,
        questionId: 389925,
      },
      {
        value: 'levothyroxine',
        hasDosage: false,
        questionId: 296025,
      },
      {
        value: 'levothyroxine (bulk)',
        hasDosage: true,
        questionId: 347088,
      },
      {
        value: 'levothyroxine (bulk) 1 mg/gram powder',
        hasDosage: true,
        questionId: 362431,
      },
      {
        value: 'levothyroxine (bulk) 100 % powder',
        hasDosage: true,
        questionId: 237253,
      },
      {
        value: 'levothyroxine 100 mcg capsule',
        hasDosage: true,
        questionId: 355507,
      },
      {
        value: 'levothyroxine 100 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 362885,
      },
      {
        value: 'levothyroxine 100 mcg tablet',
        hasDosage: true,
        questionId: 239330,
      },
      {
        value: 'levothyroxine 100 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390404,
      },
      {
        value: 'levothyroxine 100 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383551,
      },
      {
        value: 'levothyroxine 112 mcg capsule',
        hasDosage: true,
        questionId: 355495,
      },
      {
        value: 'levothyroxine 112 mcg tablet',
        hasDosage: true,
        questionId: 257160,
      },
      {
        value: 'levothyroxine 112 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383553,
      },
      {
        value: 'levothyroxine 125 mcg capsule',
        hasDosage: true,
        questionId: 355488,
      },
      {
        value: 'levothyroxine 125 mcg tablet',
        hasDosage: true,
        questionId: 244788,
      },
      {
        value: 'levothyroxine 20 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390400,
      },
      {
        value: 'levothyroxine 20 mcg/mL oral solution',
        hasDosage: true,
        questionId: 395094,
      },
      {
        value: 'levothyroxine 200 mcg capsule',
        hasDosage: true,
        questionId: 389574,
      },
      {
        value: 'levothyroxine 200 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 241562,
      },
      {
        value: 'levothyroxine 200 mcg tablet',
        hasDosage: true,
        questionId: 250544,
      },
      {
        value: 'levothyroxine 200 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383570,
      },
      {
        value: 'levothyroxine 25 mcg capsule',
        hasDosage: true,
        questionId: 355476,
      },
      {
        value: 'levothyroxine 25 mcg tablet',
        hasDosage: true,
        questionId: 237942,
      },
      {
        value: 'levothyroxine 25 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383568,
      },
      {
        value: 'levothyroxine 30 mcg/mL oral solution',
        hasDosage: true,
        questionId: 399165,
      },
      {
        value: 'levothyroxine 300 mcg tablet',
        hasDosage: true,
        questionId: 230002,
      },
      {
        value: 'levothyroxine 37.5 mcg capsule',
        hasDosage: true,
        questionId: 402032,
      },
      {
        value: 'levothyroxine 37.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397165,
      },
      {
        value: 'levothyroxine 40 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390397,
      },
      {
        value: 'levothyroxine 44 mcg capsule',
        hasDosage: true,
        questionId: 402023,
      },
      {
        value: 'levothyroxine 44 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397173,
      },
      {
        value: 'levothyroxine 50 mcg capsule',
        hasDosage: true,
        questionId: 355493,
      },
      {
        value: 'levothyroxine 50 mcg tablet',
        hasDosage: true,
        questionId: 243806,
      },
      {
        value: 'levothyroxine 50 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383550,
      },
      {
        value: 'levothyroxine 500 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 242200,
      },
      {
        value: 'levothyroxine 62.5 mcg capsule',
        hasDosage: true,
        questionId: 402012,
      },
      {
        value: 'levothyroxine 62.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397154,
      },
      {
        value: 'levothyroxine 75 mcg capsule',
        hasDosage: true,
        questionId: 355468,
      },
      {
        value: 'levothyroxine 75 mcg tablet',
        hasDosage: true,
        questionId: 238501,
      },
      {
        value: 'levothyroxine 75 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383563,
      },
      {
        value: 'levothyroxine 88 mcg capsule',
        hasDosage: true,
        questionId: 355486,
      },
      {
        value: 'levothyroxine 88 mcg tablet',
        hasDosage: true,
        questionId: 240026,
      },
      {
        value: 'levothyroxine 88 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383579,
      },
      {
        value: 'levothyroxine 125 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383582,
      },
      {
        value: 'levothyroxine 13 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383573,
      },
      {
        value: 'levothyroxine 137 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383565,
      },
      {
        value: 'levothyroxine 150 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383558,
      },
      {
        value: 'levothyroxine 175 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383561,
      },
      {
        value: 'levothyroxine 137 mcg tablet',
        hasDosage: true,
        questionId: 226061,
      },
      {
        value: 'levothyroxine 150 mcg tablet',
        hasDosage: true,
        questionId: 246273,
      },
      {
        value: 'levothyroxine 175 mcg tablet',
        hasDosage: true,
        questionId: 225902,
      },
      {
        value: 'CytomeL',
        hasDosage: false,
        questionId: 301999,
      },
      {
        value: 'CytomeL 25 mcg tablet',
        hasDosage: true,
        questionId: 250263,
      },
      {
        value: 'CytomeL 5 mcg tablet',
        hasDosage: true,
        questionId: 237429,
      },
      {
        value: 'CytomeL 50 mcg tablet',
        hasDosage: true,
        questionId: 236623,
      },
      {
        value: 'Armour Thyroid',
        hasDosage: false,
        questionId: 298245,
      },
      {
        value: 'Armour Thyroid 120 mg tablet',
        hasDosage: true,
        questionId: 233637,
      },
      {
        value: 'Armour Thyroid 15 mg tablet',
        hasDosage: true,
        questionId: 239332,
      },
      {
        value: 'Armour Thyroid 180 mg tablet',
        hasDosage: true,
        questionId: 229937,
      },
      {
        value: 'Armour Thyroid 240 mg tablet',
        hasDosage: true,
        questionId: 250548,
      },
      {
        value: 'Armour Thyroid 30 mg tablet',
        hasDosage: true,
        questionId: 251437,
      },
      {
        value: 'Armour Thyroid 300 mg tablet',
        hasDosage: true,
        questionId: 255429,
      },
      {
        value: 'Armour Thyroid 60 mg tablet',
        hasDosage: true,
        questionId: 224882,
      },
      {
        value: 'Armour Thyroid 90 mg tablet',
        hasDosage: true,
        questionId: 226943,
      },
      {
        questionId: '299900',
        value: 'Westhroid',
      },
      {
        questionId: '303622',
        value: 'Triostat',
      },
      {
        questionId: '308071',
        value: 'Thyrolar-1',
      },
      {
        questionId: '307953',
        value: 'Thyrolar-2',
      },
      {
        questionId: '303601',
        value: 'Thyrolar-3',
      },
      {
        questionId: '301146',
        value: 'Liotrix',
      },
      {
        questionId: '371624',
        value: 'WP Thyroid',
      },
      {
        questionId: '311558',
        value: 'Nature-Throid',
      },
      {
        value: 'NP Thyroid',
        questionId: '357795',
      },
      {
        value: 'NP Thyroid 120 mg tablet',
        questionId: '384698',
      },
      {
        value: 'NP Thyroid 15 mg tablet',
        questionId: '382981',
      },
      {
        value: 'NP Thyroid 30 mg tablet',
        questionId: '357746',
      },
      {
        value: 'NP Thyroid 60 mg tablet',
        questionId: '357763',
      },
      {
        value: 'NP Thyroid 90 mg tablet',
        questionId: '357753',
      },
    ],
  },
  {
    id: 'medications',
    type: 'medicationList',
    endpoint: 'medications',
    // skip: 'supplements',
    skip: 'allergies',
    useUsaRx: true,
    title: 'Other Medications and Supplements',
    prompt: 'Please add the other medications and supplements you are currently taking',
    other: { questionId: '301410' },
    prefix: 'Medications currently taking -',
    extend: true,
    isInputOnly: true,
    options: [],
    nothingText: "I don't take other medications",
  },


  {
    id: 'allergies',
    type: 'allergies',
    endpoint: 'allergies',
    prompt: 'Do you have any allergies to medications or other substances?',
    options: [
      {
        questionId: '12990',
        prefix: 'Allergies to medications / other substances -',
        answer: 'Y',
        value: 'Yes',
        placeholder: 'Explain',
      },
      {
        questionId: '12990',
        answer: 'NKDA',
        value: 'No',
      },
    ],
  },
  {
    id: 'any-new-medical',
    type: 'input',
    endpoint: 'medicalHistory',
    prompt: 'Have any medical conditions or anything else that may be relevant to your health history changed since your last visit?',
    defaults: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? { '543': '' } : { '562': '' }, 
    description: `Please do not share urgent symptoms or information since this is not monitored continuously.`,
    prefix: '',
    answer: 'Y',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '543' : '562', 
        placeholder: 'Enter the details',
      },
    ],
  },
  {
    id: 'blood-pressure-measured-recently',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: 'Have you had your blood pressure measured in the last six months?',
    description: `It's important to provide a recent reading as it can affect what types of medications are safe for you.`,
    options: [
      { questionId: 'ans', answer: 'Yes', display: 'Yes', value: 'Yes', nextQuestion: 'blood-pressure-range' },
      {
        questionId: 'ans',
        answer: 'No',
        display: 'No',
        value: 'No',
        nextQuestion: 'blood-pressure-measured-need',
      },
    ],
  },
  {
    id: 'blood-pressure-measured-need',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: `We'll need a blood pressure reading`,
    description: `Go ahead and complete your health assessment, but your prescription won't be processed until you tell us your blood pressure numbers.`,
    description2:`You can have your blood pressure checked at most pharmacies or use a home blood pressure cuff. If you aren't sure when you last had it taken, call your doctor's office and ask if it was within six months and what the numbers were. After you submit your request we'll send you a message reminding you to tell us your blood pressure.`,
    options: [
      { questionId: 'ans', answer: 'Got it', display: 'Got it', value: 'Got it', nextQuestion: 'heart-rate-range' },      
    ],
  },
  {
    id: 'blood-pressure-range',
    type: 'single',
    endpoint: 'vitals',
    prompt: 'What was your most recent blood pressure reading?',
    femaleOnly: true,
    options: [
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '129/80',
        display: 'Normal (Less than 129/80)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '130/80',
        display: 'Elevated (130-139/80-89)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '140/90',
        display: 'High (140-149/90-99)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '150/100',
        display: 'Very High (More than 150/100)',
      },
    ],
  },

  // {
  //   id: 'blood-pressure-range',
  //   type: 'input',
  //   endpoint: 'vitals',
  //   skipText: `I don't know`,
  //   prompt: 'What is your current or average blood pressure range?',
  //   description: 'Enter your blood pressure reading in the format "systolic/diastolic" (e.g., 120/80). Make sure there are no extra spaces or characters',
  //   prefix: '',
  //   answer: 'Y',
  //   options: [
  //     {
  //       questionId: 'VITALS_BLOODPRESSURE',
  //       placeholder: 'Blood pressure in the format "systolic/diastolic" (e.g., 120/80)',
  //     },
  //   ],
  // },

  {
    id: 'heart-rate-range',
    type: 'input',
    endpoint: 'vitals',
    skipText: `I don't know`,
    prompt: 'What is your current or average heart rate range?',
    description: 'Enter your heart rate value in bpm (e.g., 80)',
    prefix: '',
    answer: 'Y',
    inputmode: 'numeric',
    options: [
      {
        questionId: 'VITALS_HEARTRATE',
        placeholder: 'your heart rate value in bpm (e.g., 80)',
        inputmode: 'numeric',
      },
    ],
  },
  {
    id: 'symptoms-since-starting',
    type: 'multiSelect',
    extend: true,
    skip: 'appetite',
    skipText: 'I have no symptoms',
    placeholder:'Do you want to provide more details?',
    endpoint: 'problems',
    questionId: '401207004',
    prompt: 'Have you experienced any of the following since starting medication?',
    options: [
      {
        answer: 'Gastrointestinal symptoms (e.g. abdominal pain fullness reflux nausea vomiting)',
      },
      {
        answer: 'Chest pain heart palpitations or racing heart',
      },
      {
        answer: 'Concerning and/or serious mood changes or suicidal thoughts',
      },
      {
        answer: 'Seizures',
      },
      {
        answer: 'Food cravings',
      },
      {
        answer: 'Other symptoms or side effects',
      },
      {
        answer: 'Hospitalization since your last visit',
      },
      {
        answer: 'Changes to your overall health or medical history',
      },
      {
        answer: 'None of the above',
        isClear: true,
      },
    ],
  },
  {
    id: 'appetite',
    type: 'single',
    endpoint: 'problems',
    prompt: 'How would you describe your appetite?',
    options: [
      {
        questionId: '249473004',
        answer: 'Significantly less',
        display: 'Significantly less',
      },
      {
        questionId: '249473004',
        answer: 'Slightly less',
        display: 'Slightly less',
      },
      {
        questionId: '249473004',
        answer: 'About the same',
        display: 'About the same',
      },
      {
        questionId: '249473004',
        answer: 'Slightly more',
        display: 'Slightly more',
      },
      {
        questionId: '249473004',
        answer: 'Significantly more',
        display: 'Significantly more',
      },
    ],
  },
  {
    id: 'vitals',
    type: 'HeightWeight',
    endpoint: 'socialHistory',
    prompt: 'Please enter your height and weight',
    defaults: { LOCAL_121: '', LOCAL_122: '' },
    schema: Yup.object().shape({
      LOCAL_121: Yup.string().required('Required'),
      LOCAL_122: Yup.string().required('Required'),
    }),
    options: [
      { questionId: 'LOCAL_121', placeholder: `Height (e.g. 6'3")` },
      {
        questionId: 'LOCAL_122',
        placeholder: 'Weight (pounds)',
        // inputType: 'number',
      },
    ],
  },
  {
    id: 'weightGoal',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'What is yout goal weight?',
    defaults: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? { LOCAL_203: '' } : { LOCAL_581: '' },
    description: `Please note that while this information is helpful, medical decisions will be made by the clinicians keeping clinical evidence and patient safety at the forefront.`,
    prefix: 'Goal Weight:',
    inputmode: 'numeric',
    answer: 'Y',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL_203' : 'LOCAL_581',
        placeholder: 'Enter your goal weight in pounds (lbs)',
      },
    ],
  },
  {
    id: 'last-injection',
    type: 'input',
    endpoint: 'medicalHistory',
    prompt: 'How many days has it been since you took your last weight loss medication (injection or pill)?',
    answer: 'Y',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '525' : '544',
        placeholder: 'Enter how many days',
      },
    ],
  },
  {
    id: 'how-feel',
    type: 'single',
    endpoint: 'medicalHistory',
    prompt: 'How are you feeling about your current medication dosage?',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        answer: 'Y',
        value: 'Experiencing no or mild side effects and open to increasing my dose.',
        display: 'Experiencing no or mild side effects and open to increasing my dose.',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        answer: 'Y',
        value: 'Comfortable with my current dose and would like to stay at this level.',
        display: 'Comfortable with my current dose and would like to stay at this level.',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        answer: 'N',
        value: `I’d prefer to decrease my dose.`,
        display: `I’d prefer to decrease my dose.`,
      },
    ],
  },
  {
    id: 'concerns',
    type: 'input',
    endpoint: 'problems',
    skip: 'finished',
    // onlyFirstTime: true,
    prompt: 'Do you have any further information which you would like your provider to know?',
    description: `Please do not include urgent or emergent medical information here, as this is not reviewed immediately.`,
    defaults: { '185087000': '' },
    prefix: 'Other medical concerns / details -',
    extend: true,
    options: [{ questionId: '185087000', placeholder: 'Add them here...' }],
  },
  {
    id: 'finished',
    type: 'information',
    title: 'You Are All Set',
    onlyFirstTime: false,
    text: ['Your appointment is scheduled an you will receive an email with instructions on how to complete your online visit.'],
    buttonText: 'My Dashboard',
    status: 'completed',
    link: '/',
  },
  {
    id: 'disqualified',
    type: 'disqualified',
    status: 'disqualified',
    onlyFirstTime: false,
    link: '/',
  },
];